var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Alert',{attrs:{"title":_vm.lc.title,"content":_vm.lc.description,"status":"info"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('Button',{attrs:{"label":_vm.lc.wikiButton,"href":"https://www.locaweb.com.br/ajuda/categorias/criador-de-sites/","target":"_blank","color":"primary"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }